import $ from "../../../libs/jquery-3.3.1.min.js"
import {gsap, PixiPlugin} from "../../../libs/gsap/all.js"
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras'
import {Ticker} from 'pixi.js';
import {GameTitle} from "./components/GameTitle";
import {PhotoCreditsPopup} from "./components/PhotoCreditsPopup";
import {Soundscape} from "./components/Soundscape";

let lastProgress = 0;

// Constructor
export class BaseMiniGame extends PIXI.Application {

  constructor(data) {
    super();
    this.data = data;
    this.assets = {};

    this.appWidth = 500;
    this.appHeight = 500;

    // Language switchers texts
    this.interfaceTextTimeline = false;
    this.interfaceText = {
      "en": [],
      "fr": [],
    }
  }

  async init(target) {
    PixiPlugin.registerPIXI(PIXI);

    const domTarget = (typeof target == "string") ? $(target).get(0) : target;
    $(domTarget).width(this.appWidth + "px")
    $(domTarget).height(this.appHeight + "px")

    await super.init({
      width: this.appWidth,
      height: this.appHeight,
      backgroundColor: 0x000000,
      resolution: window.devicePixelRatio || 1,
      antialias: true,
      canvas: domTarget,
      autoStart: false,
    });

    this.loaded = true;

    this.ticker.autoStart = false;
    this.ticker.stop(); // make sure the ticker is not running

    // this.ticker.maxFPS = 60; // limit the ticker to 60 fps so we get the same speed as the final screen on our high refresh rate screens

    return this;
  }

  // To be overridden in subclasses
  async buildStage() {
  }

  buildAppTitle() {
    const gameTitle = new GameTitle(128, 128, 1.0, this);
    this.stage.addChild(gameTitle);
  }

  activate() {
    // Enable render

    this.start();
  }

  deactivate() {
    // Disable render
    this.stop();
  }

  // To be overridden in subclasses
  begin() {
  }

  buildOverlay() {
    this.fadeOverlayLayer = new PIXI.Container();
    this.fadeOverlayLayer._zIndex = 99999999;
    this.stage.addChild(this.fadeOverlayLayer);

    let overlayBackground = new PIXI.Sprite(this.assets["fade-overlay-background"]);
    this.fadeOverlayLayer.addChild(overlayBackground);

    this.fadeOverlayLayer.eventMode = "none";
  }

  buildTextPopupLayer() {
    this.textLayer = new PIXI.Container();
    this.popupLayer = new PIXI.Container();
    this.popupLayer._zIndex = 999999; // make sure popup is on top of everything
    this.popupLayer.position.set(this.appWidth / 2, this.appHeight / 2);
    this.stage.addChild(this.textLayer);
    this.stage.addChild(this.popupLayer);
    this.textPopups = [];
  }

  buildPhotoCreditsLayer() {
    // NOTE: the photosCreditsLayer layer should already exist at this point
    
    // Photo credits
    if (this.data.photos_credits) {
      const creditsDataKeys = Object.keys(this.data.photos_credits);
      creditsDataKeys.forEach((key) => {
        const creditsData = this.data.photos_credits[key];
        const photoEl = this[key];
        const photoCreditsEl = new PhotoCreditsPopup(photoEl.position.x + (photoEl.width / 2) - 20, photoEl.position.y - 20, "#343B6F", 0.9, creditsData, this);
        this.textPopups.push(photoCreditsEl); // add to textPopups for easier reset
        if (photoCreditsEl.getButton()) {
          photoCreditsEl.getButton().position.x -= photoCreditsEl.buttonSize / 2 - creditsData.offset.x;
          photoCreditsEl.getButton().position.y -= photoCreditsEl.buttonSize / 2 - creditsData.offset.y;
          this.photosCreditsLayer.addChild(photoCreditsEl.getButton());
        }
        if (photoCreditsEl.getPopup()) {
          this.popupLayer.addChild(photoCreditsEl.getPopup()); // let's use the same layer as the text popups
        }
      })
    }
  }

  buildSoundscape() {
    this.soundscape = new Soundscape(...this.data.soundscape)
  }

  // To be overridden in subclasses
  progress(value) {
    if (lastProgress !== value) {
      if (this.soundscape) this.soundscape.updateProgress(value)
      lastProgress = value;
    }
  }

  fadeOutOverlay() {
    gsap.fromTo(this.fadeOverlayLayer, {
      pixi: {
        alpha: 1,
      }
    }, {
      pixi: {
        alpha: 0,
      },
      duration: 1.5,
      overwrite: "auto"
    })
  }

  fadeInOverlay(duration) {
    duration = typeof duration !== "undefined" ? duration : 2;

    gsap.fromTo(this.fadeOverlayLayer, {
      pixi: {
        alpha: 0,
      }
    }, {
      pixi: {
        alpha: 1,
      },
      duration: duration,
      overwrite: "auto"
    })
  }

  // To be overridden in subclasses
  reset() {
  }

  async assetLoader() {
    // To be overridden in subclasses
  }

  complete() {
    // console.log("COMPLETE");
    this.dispatchEvent(new CustomEvent("complete", {detail: "C'est complété."}))
  }

  dispatchEvent(...args) {
    this.canvas.dispatchEvent(...args)
  }

  on(...args) {
    this.canvas.addEventListener(...args);
  }

  /**
   * Language switcher for interface text
   * Show/Hide using language
   * @param lang
   * @param skipTransition
   */
  interfaceLanguageSwitch(lang, skipTransition = false) {
    const textShownArray = lang === "fr" ? this.interfaceText["fr"] : this.interfaceText["en"];
    const textHiddenArray = lang === "fr" ? this.interfaceText["en"] : this.interfaceText["fr"];

    // Switch timeline
    if (this.interfaceTextTimeline) {
      this.interfaceTextTimeline.kill();
      this.interfaceTextTimeline = false;
    }
    this.interfaceTextTimeline = gsap.timeline();

    // Update hidden
    textHiddenArray.forEach(text => {
      if (skipTransition) {
        text.alpha = 0.0;
      } else {
        this.interfaceTextTimeline.to(text, {alpha: 0.0, duration: 0.4}, 0.0);
      }
    });

    // Update shown
    textShownArray.forEach(text => {
      if (skipTransition) {
        text.alpha = 1.0;
      } else {
        this.interfaceTextTimeline.to(text, {alpha: 1.0, duration: 0.4}, 0.4);
      }
    });
  }
}
